module.exports = __webpack_public_path__ + "static/media/2000 Japan.e46f9b95.jpg";